import { render, staticRenderFns } from "./HojaDeIngreso.vue?vue&type=template&id=7237ba5c&scoped=true&"
import script from "./HojaDeIngreso.vue?vue&type=script&lang=js&"
export * from "./HojaDeIngreso.vue?vue&type=script&lang=js&"
import style0 from "./HojaDeIngreso.vue?vue&type=style&index=0&id=7237ba5c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7237ba5c",
  null
  
)

export default component.exports